export default __webpack_public_path__ + "static/media/hht1_ep13_minisitcom_03.2655c1bb.png";